import { IObservable } from '~/rage/utils';
import { IClientConfigs, Role } from '~/shared';
import { GameConfigService } from '../GameConfigService';
import { VarsService } from '../VarsService';
import { IAccessControlService } from './accessControlServiceTypes';

export class AccessControlService implements IAccessControlService {
	private roleHierarchy: Partial<Record<Role, number>> | null = null;

	private currentRoleLevel: number = 0;

	constructor(
		private readonly vars: VarsService,
		gameConfig: GameConfigService,
	) {
		gameConfig.getConfigs().subscribe(this.handleGameConfigChange.bind(this));
		gameConfig.getConfigs().subscribe(() => this.handleRoleUpdate());
		this.getCurrentRole().subscribe(() => this.handleRoleUpdate());
	}

	private handleGameConfigChange(config: Partial<IClientConfigs>) {
		if (!config?.accessControl) {
			return;
		}

		this.roleHierarchy = config.accessControl.roleHierarchy ?? null;
	}

	private getRoleLevel(role: Role): number {
		if (!this.roleHierarchy) {
			return 0;
		}

		return this.roleHierarchy[role] || 0;
	}

	private handleRoleUpdate(): void {
		if (!this.roleHierarchy) {
			return;
		}

		const currentRole = this.getCurrentRole().getValue();

		this.currentRoleLevel = this.getRoleLevel(currentRole);
	}

	public getCurrentRole(): IObservable<Role> {
		return this.vars.get<Role>('accessControl:role', Role.PLAYER);
	}

	public hasMinimumRole(role: Role): boolean {
		const requiredRoleLevel = this.getRoleLevel(role);

		return this.currentRoleLevel >= requiredRoleLevel;
	}
}
